import React, { useState } from "react";

import "./styles.css";
import Tagger from "./tagger";


export function Upload() {
  const [text, setText] = useState();

  // const test = e => {
  //   console.log(e.target.files);
  // };

  let fileReader;

  const onChange = e => {
    let file = e.target.files;
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsText(file[0]);
  };

  // const deleteLines = (string, n = 1) => {
  //   console.log("remove lines");
  //   return string.replace(new RegExp(`(?:.*?\n){${n - 1}}(?:.*?\n)`), "");
  // };

  const cleanContent = string => {
    string = string.replace(/^\s*[\r\n]/gm, "");
    let array = string.split(new RegExp(/[\r\n]/gm));
    console.log(array);
    array.splice(0, 3);
    array.splice(-3);
    return array.join("\n");
  };

  const handleFileRead = e => {
    let content = fileReader.result;
    content = cleanContent(content);
    setText(content);
  };
  return (
    <div>
      <div>
        <input type="file" name="myfile" onChange={onChange} />
      </div>
      {/* {text && <pre>{text}</pre>} */}
      {text ? <Tagger
      text = {text ? text : ""}
      ></Tagger> : ""}
    </div>
  );
}